var rich_content_viewer_default = {
  "fontElementMap": "LT2Ty",
  "wrapper": "v-SZO",
  "pluginContainerMobile": "RPlDD",
  "viewer": "nU8wz",
  "android": "HFycL",
  "rootedTraversedContent": "MS-WH",
  "atomic": "ZIWFF",
  "toolbar": "_8Pezs",
  "block": "Tb28B"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
